import type { ReactNode } from 'react'

import './system.css'

export type ButtonVariant = 'primary' | 'quiet' | 'danger'

export function Button({
  variant = 'primary',
  size = 'md',
  pill = false,
  type = 'button',
  full = false,
  disabled = false,
  onClick,
  children,
}: {
  variant?: ButtonVariant
  size?: 'md' | 'sm'
  pill?: boolean
  type?: 'button' | 'submit'
  full?: boolean
  disabled?: boolean
  onClick?: () => void
  children: ReactNode
}) {
  const classes = ['button']

  if (variant !== 'primary') {
    classes.push(`button--${variant}`)
  }

  if (size === 'sm') {
    classes.push('button--sm')
  }

  if (pill) {
    classes.push('button--pill')
  }

  if (full) {
    classes.push('button--full')
  }

  return (
    <button
      className={classes.join(' ')}
      type={type}
      disabled={disabled}
      {...(onClick ? { onClick } : {})}
    >
      {children}
    </button>
  )
}
